import React from "react";

const OverlayNotice = ({ children, wrapperClassName }) => {
    return (
        <div className={`${wrapperClassName} bg-black fixed top-0 bottom-0 right-0 left-0 w-full h-full z-50`}>
            <div className="p-5 flex items-center justify-center w-full h-full">
                <div className="text-center">
                    {children}
                </div>
            </div>
        </div>
    )
}

export default OverlayNotice